var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-delete": false,
              "show-new": false,
              "show-save": false,
              "show-cancel": false,
              title: _vm.jobInvoicedObj[_vm.filter.selectedType],
              "show-print": _vm.showPrint,
            },
            on: { appDetailHeaderButtonClicked: _vm.handlePrint },
          }),
          _c("div", { staticClass: "tile is-ancestor is-parent" }, [
            _c(
              "div",
              { staticClass: "tile is-vertical is-parent" },
              [
                _c("job-invoiced-menu-bar", {
                  attrs: {
                    "is-loading": _vm.isLoading,
                    "total-jobs": _vm.totalJobs,
                    "total-amount": _vm.totalAmount,
                    "include-gst": _vm.includeGst,
                    "current-month": _vm.currentMonth,
                    "current-year": _vm.currentYear,
                    "fiscal-year-name": _vm.fiscalYearName,
                  },
                  on: {
                    "selected-type": _vm.changeType,
                    "filter-list": _vm.filterList,
                  },
                  model: {
                    value: _vm.currentFiscalYearSettings,
                    callback: function ($$v) {
                      _vm.currentFiscalYearSettings = $$v
                    },
                    expression: "currentFiscalYearSettings",
                  },
                }),
                _vm.filter.selectedType === 0
                  ? _c(
                      "div",
                      { staticClass: "tile is-child box" },
                      [
                        _c(
                          "bulma-table",
                          {
                            staticClass:
                              "is-striped is-narrow is-fullwidth is-hoverable",
                            attrs: {
                              columns: _vm.columns,
                              data: _vm.sortedData,
                              "total-rows": _vm.entitySummaries.length,
                              "page-size": _vm.entitySummaries.length,
                              "is-loading": _vm.isLoading,
                              "sort-column": _vm.sortColumn,
                              "sort-order": _vm.sortOrder,
                              "show-pagination": false,
                              "has-sticky-header": true,
                              "sticky-header-top": "10.25rem",
                            },
                            on: { sort: _vm.sort },
                          },
                          [
                            _vm._l(_vm.sortedData, function (item, index) {
                              return _c(
                                "tr",
                                {
                                  key: index,
                                  class: {
                                    "is-selected": _vm.selectedRow === index,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.highlightSelected(
                                        index,
                                        $event
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("td", { staticClass: "col-5" }, [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.quoteClick(item.quoteId)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item.quoteNoRef))]
                                    ),
                                  ]),
                                  _c("td", { staticClass: "col-8" }, [
                                    _vm._v(_vm._s(item.jobStageDesc)),
                                  ]),
                                  _c("td", { staticClass: "col-10" }, [
                                    _vm._v(_vm._s(item.owner)),
                                  ]),
                                  _c("td", { staticClass: "col-5" }, [
                                    _vm._v(_vm._s(item.rego)),
                                  ]),
                                  _c("td", { staticClass: "col-12" }, [
                                    _vm._v(_vm._s(item.makeModel)),
                                  ]),
                                  _c("td", { staticClass: "col-10" }, [
                                    _vm._v(_vm._s(item.debtorName)),
                                  ]),
                                  _c("td", { staticClass: "col-5" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatDateLocale(
                                          item.invoiceDate,
                                          _vm.$userInfo.locale
                                        )
                                      ) + " "
                                    ),
                                  ]),
                                  _c("td", { staticClass: "col-5" }, [
                                    _vm._v(_vm._s(item.invoiceNoRef)),
                                  ]),
                                  _c(
                                    "td",
                                    { staticClass: "has-text-right col-5" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatNumber(
                                            item.totalIncGst,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            _c("template", { slot: "empty" }, [
                              _c("section", { staticClass: "section" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content has-text-grey has-text-centered",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { icon: "icon is-large" } },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-48px mdi-emoticon-sad",
                                        }),
                                      ]
                                    ),
                                    _c("p", [_vm._v("Nothing")]),
                                  ]
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.filter.selectedType === 1
                  ? _c(
                      "div",
                      { staticClass: "tile is-child box" },
                      [
                        _c(
                          "bulma-table",
                          {
                            staticClass:
                              "is-striped is-narrow is-fullwidth is-hoverable",
                            attrs: {
                              columns: _vm.columns,
                              data: _vm.sortedData,
                              "total-rows": _vm.entitySummaries.length,
                              "is-loading": _vm.isLoading,
                              "sort-column": _vm.sortColumn,
                              "sort-order": _vm.sortOrder,
                              "show-pagination": false,
                              "has-sticky-header": true,
                              "sticky-header-top": "10.25rem",
                            },
                            on: { sort: _vm.sort },
                          },
                          [
                            _vm._l(_vm.sortedData, function (item, index) {
                              return _c(
                                "tr",
                                {
                                  key: "item" + index,
                                  class: {
                                    "is-selected": _vm.selectedRow === index,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.highlightSelected(
                                        index,
                                        $event
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "col-5 has-text-weight-bold",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(item.monthName) +
                                          " " +
                                          _vm._s(item.year)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "col-5 has-text-centered" },
                                    [_vm._v(_vm._s(item.workingDays))]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "col-5 has-text-centered" },
                                    [
                                      _c("div", [
                                        _vm._v(_vm._s(item.totalInvoices)),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "has-text-right col-5" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatCurrency(
                                            _vm.getAvgDailyInvoiced(
                                              item.totalIncGst,
                                              item.workingDays
                                            ),
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "has-text-right col-5" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatCurrency(
                                            _vm.getMonthlyTarget(
                                              item.monthlyTarget
                                            ),
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    { staticClass: "has-text-right col-5" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatCurrency(
                                            item.totalIncGst,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            _c("template", { slot: "empty" }, [
                              _c("section", { staticClass: "section" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content has-text-grey has-text-centered",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { icon: "icon is-large" } },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-48px mdi-emoticon-sad",
                                        }),
                                      ]
                                    ),
                                    _c("p", [_vm._v("Nothing")]),
                                  ]
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }